import React, {useMemo} from "react";

import {TLevelObject, World} from "@repo/shared";

import {useGroup} from "~/contexts/group/GroupProvider";

import CoopGame from "./CoopGame";
import GameLoopRunner from "./GameLoopRunner";
import SinglePlayerGame from "./SinglePlayerGame";

const GameContainer: React.FC<{id: string; levelData: TLevelObject[]}> = ({
  id,
  levelData,
}) => {
  const {isCoopMode} = useGroup();
  const world = useMemo(() => new World(levelData), [levelData]);

  return (
    <>
      <GameLoopRunner />
      {isCoopMode ? (
        <CoopGame levelId={id} world={world} />
      ) : (
        <SinglePlayerGame levelId={id} world={world} />
      )}
    </>
  );
};

export default GameContainer;
